import React, { useState, useEffect } from 'react';
import { isWeb } from '../util/platform';
import { TextInput, StyleSheet } from 'react-native'

import AppStyles from '../AppStyles';
import { useTranslation } from '../i18n';

// Date input: native HTML date picker on web; on native, a YYYY-MM-DD text
// field that only commits complete/cleared values on end-editing so partial
// typing doesn't trigger refetches.
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const DateInput = ({ value, onCommit, min, max, accessibilityLabel }) => {
  const { t } = useTranslation('common');

  const [draft, setDraft] = useState(value);

  // Stay in sync when the value is changed externally (e.g. Clear button)
  useEffect(() => {
    setDraft(value);
  }, [value]);

  if (isWeb()) {
    return (
      <input
        type="date"
        aria-label={accessibilityLabel}
        style={{
          backgroundColor: '#FFFFFF',
          border: '1px solid #E5E5E5',
          borderRadius: 8,
          padding: '8px 10px',
          fontSize: 13,
          fontFamily: 'inherit',
          color: '#000',
        }}
        value={value}
        min={min || undefined}
        max={max || undefined}
        onChange={(e) => onCommit(e.target.value)}
      />
    );
  }

  return (
    <TextInput
      value={draft}
      onChangeText={setDraft}
      onEndEditing={() => {
        if (draft === '' || DATE_PATTERN.test(draft)) {
          onCommit(draft);
        } else {
          setDraft(value); // revert invalid input
        }
      }}
      placeholder={t('common:datePlaceholder')}
      placeholderTextColor={AppStyles.colorSet.textMuted}
      accessibilityLabel={accessibilityLabel}
      style={styles.dateTextInput}
      keyboardType="numbers-and-punctuation"
      maxLength={10}
    />
  );
};

const styles = StyleSheet.create({
  dateTextInput: {
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#E5E5E5',
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 10,
    fontSize: 13,
    minWidth: 120,
  },
});

export default DateInput;
